export const environment = {
  production: true,
  config: {
    api: {
      uri: "http://localhost:3000"
    },
    backendUrl: 'https://www.comune.padova.it',
  }
};
